import React from 'react';
import cx from 'classnames';
import store from 'javascripts/store.js';
import {observer} from 'mobx-react';

@observer
class DonateFormSubscriptionToggle extends React.Component {
  toggle = (isSubscription) => {
    store.donateForm.step = 'amount';
    store.donateForm.paymentTab = 'stripe';
    store.donateForm.creditCardStep = 1;
    store.donateForm.isSubscription = isSubscription;
    store.donateForm.phoneNumber.hiddenFieldValue = '';
    store.donateForm.setCustomDefaultAmount();
  };

  render() {
    if(!store.donateForm.showSubscriptionOption) return null;

    const {
      isSubscription,
    } = store.donateForm;

    return (
      <div>
        <div className='monthly-subscription toggle-buttons'>
          <a
            className={cx('toggle-one-time', {'active': !isSubscription})}
            onClick={() => this.toggle(false)}
          >
            Give Once
          </a>
          <a
            className={cx('toggle-monthly', {'active': isSubscription})}
            onClick={() => this.toggle(true)}
          >
            Monthly
          </a>
        </div>
      </div>
    );
  }
}

export default DonateFormSubscriptionToggle;
